<template>
	<div>
		<SupportBanner />
		<div class="content-zsy">
			<div class="title-wrap">
				<h3>안심보장 프로그램</h3>
				<p>안전한 배송대행과 고로켓고 이용 고객의 안심을 위해<br>준비한 고로켓고 보상 프로그램</p>
			</div>
			<div class="center mb50">
				<img src="../../assets/list/insure-img1.png" loading="lazy" class="hidden-xs" alt="안심보장 프로그램">
				<img src="../../assets/list/insure-m-img1.png" loading="lazy" class="img-responsive visible-xs" alt="안심보장 프로그램">
			</div>
			<div class="document-insure">
				<h4>사고 유형 및 보상</h4>
			</div>
			
			<div class="expand-list mb50">
				<el-collapse accordion>
				  <el-collapse-item>
				    <template slot="title">
						<span class="badge">국내</span><span class="name">1. 국내로 배송된 상품의 파손 또는 분실</span>
				    </template>
					<div class="expand-content">
						<p>1. 국내로 물품 발송 후 물품이 파손된 경우<br>
							- 포장보완을 신청하지 않은 경우 보상에서 제외 (보완 포장을 하였더라도 심한 외부 충격에 의한 파손이 아닌 경우 보상에서 제외될 수 있습니다.)<br>
							- 택배사 배송 중 파손은 해당 택배사 보상규정 기준으로 처리<br>
							- 택배사 회수 후 택배사 확인 후 보상 여부 결정 (회수 후 보상처리된 제품은 반환 불가합니다.)</p>
						<p>2. 물품 발송 후 국내 택배사에서 분실된 경우<br>
							- 국내 택배사와 분실 여부 확인 후 처리 (택배 인계 후 30일 이내 접수 가능)<br>
							- 택배 기사와 직접 분실 확인된 경우 즉시 접수 가능<br>
							- 경동택배 분실은 택배 접수일로부터 14일 이내에만 보상접수 가능합니다. (7일 이상 이동내역 없을 경우 구매내역서 증빙 시 접수 가능합니다.)<br>
							- 택배사 분실의 경우 보상까지 3개월 이상 소요될 수 있습니다.</p>
						<p>3. 한국 도착 후 세관 분실 및 파손<br>
							- 신고 금액으로 보상 가능(허위신고시 보상 불가)<br>
							- 택배사 보상기준에 충족되어야 보상이 가능하며, 보상기준 미비 시 반려됩니다.</p>
					</div>
				  </el-collapse-item>
				  <el-collapse-item>
					  <template slot="title">
							<span class="badge">해외</span><span class="name">2. 물류센터 내 분실 OR 선적 전 파손 및 분실</span>  	
					  </template>
						<div class="expand-content">
							<p>1. 해외 물류센터 입고 이후 분실된 경우<br>
								- 구매 금액가(해외 쇼핑몰가 기준) 보상 가능<br>
								- 입고 전 화물은 보상 대상이 아닙니다.
							</p>
							<p>2. 물류센터 출고 후 선적 전 파손 및 분실된 경우<br>
							   - 출고 이후 선적 전 수출국 세관에 의해 검사 중 분실/파손이 있을 수 있으며, 분실 시엔 고로켓고에서 보상 처리 가능 (파손 시엔 포장보완 신청하지 않은 경우 보상에서 제외/면책 상품 보상제외)<br>
								- 구매 금액가 보상 가능 (신고 금액 기준 / 허위신고 금액은 보상 제외)
							</p>
							<p>주요 증빙자료<br>- 해외 쇼핑몰 구매내역서</p>
						</div>
					
				  </el-collapse-item>
				  <el-collapse-item>
					<template slot="title">
						<span class="badge">공통</span><span class="name">3. 정밀검수 이미지와 다르게 배송</span>  	
					</template>
				    <div class="expand-content">
						<p>- 정밀검수 이미지와 다르게 큰 오염이나 얼룩이 있는 경우 구매 금액가 보상 가능(반송 조건)</p>
						<p>- 반송없이 물품 사용 시 : 물품 금액의 10% 보상<br>정밀검수는 육안으로 확인하는 것으로 미세한 오염,스크래치등의 경우 보상 제외됩니다.택배 배송 중 외부 충격에 의한 오염은 택배사 보상 기준에 따릅니다.</p>
						<p>주요 증빙자료<br>
						- 택배 송장사진<br>
						- 겉박스 상태 사진<br>
						- 겉박스 파손부위 사진<br>
						- 박스 내부 포장 상태 사진<br>
						- 내품 사진
						</p>
					</div>
				  </el-collapse-item>
				  <el-collapse-item title="可控 Controllability">
					<template slot="title">
						<span class="badge">공통</span><span class="name">4. 누락발송, 오배송</span>  	
					</template>
				    <div class="expand-content">
						<p>1. 신청서에 작성한 물품이 다른 사람의 물품과 바뀌어 배송된 경우<br>- 오배송 상품 회수 후 본상품 재발송으로 처리되며, 배송비를 직접 지불한 경우 배송비 보상 가능 (고로켓고에서 자진 회수, 재발송 처리된 경우 별도의 보상금이 지급되지는 않습니다.)<br>- 오배송 상품 미회수 시 보상 제외</p>
						<p>2. 신청서에 작성한 트래킹번호를 기준으로 누락된 물품이 있는 경우<br>- 검수 사진에 해당 트래킹번호 송장 및 상품이 있음에도 누락된 경우 재발송 배송비 보상 가능<br>- 기본 검수 사진에 해당 트래킹번호 송장 및 상품이 없는 경우는 보상 제외(검수 사진을 반드시 확인 후 출고 진행바랍니다.)<br>- 등록한 이미지가 작아서 대조 확인이 불가한 경우 또는 조립식 상품이라 조립 전에 확인이 불가한 경우에는 보상에서 제외<br>- 중복송장으로 기본검수 요청 없이 진행된 경우 누락이나 오배송에 대한 보상이 불가합니다.</p>
						<p>주요 증빙자료<br>- 택배 송장사진<br>- 포장내품 사진<br>- CCTV영상</p>
					</div>
				  </el-collapse-item>
				  <el-collapse-item title="可控 Controllability">
					<template slot="title">
						<span class="badge">공통</span><span class="name">5. 실중량 차이 보상</span>  	
					</template>
				    <div class="expand-content">
						<p>고로켓고에서 책정된 중량과 화물 수령 후 중량이 다른 경우<br>- 중량 차이만큼 배송비 차액 보상 가능<br>- (부피무게로 측정된 상품은 제외)</p>
						<p>주요 증빙자료<br>- 택배송장 사진<br>- 겉박스 상태 사진<br>- 미개봉 상태에서 화물용 전자저울로 측정한 사진 (가정용 체중계 불가)</p>
					</div>
				  </el-collapse-item>
				</el-collapse>
			</div>
			
			<div class="document-insure">
				<h4>사고 접수 및 보상 프로세스</h4>
			</div>
			<div class="process">
				<ul>
					<li>
						<strong>1. 사고 확인<span class="color-blue">신청서 취소/수정 가능</span></strong>
						<p>상품을 수령 후 문제를 발견시 영업일 3일 이내에 고객센터 1:1 문의에서 직접 접수 또는 카카오톡 채널로 문의해주세요.<br><br class="visible-xs">
							배송신청 주문번호, 운송장번호, 사진 첨부 등으로 사고 접수 가능 여부를 확인합니다.<br><br class="visible-xs">
							수령하신 날로 부터 3일 이내 사고 접수가 가능하며, 이후는 접수가 불가능합니다.</p>
					</li>
					<li>
						<strong>2. 사고 접수<span class="color-red">신청서 수정 불가</span></strong>
						<p>사고 접수는 각 사고 유형별로 요구하는 증빙자료를 반드시 확인한 후 첨부해주세요.<br>
							(유형별 요구 증빙자료는 상단 ‘사고 유형 및 보상’ 세부 내역 참조)<br><br>
							1. 구매 증빙 자료 : 해외 사이트 구매내역 + 결제내역(카드 결제 내역)<br><br class="visible-xs">
							2. 사진 자료 : 수령하신 박스 외관 사진(송장 포함) ,상세 포장 상태, 파손의 경우 파손 상태 세부 사진 3장 이상 등<br>
							- 사고 유형별 요구하는 사진이 다르므로 반드시 확인 후 첨부 바랍니다.<br><br class="visible-xs">
							3. 통장사본<br>
							팀머니(예치금)로 보상가능(환불 불가)</p>
					</li>
					<li>
						<strong>3. 보상진행<span class="color-red">신청서 수정 불가</span></strong>
						<p>보상 시, 해당 상품에 대해서는 반송을 원칙으로 하며, 해당 반송비는 사전연락건에 한하여 고로켓고에서 부담합니다.<br>
							보상 방식과 내용에 대해 동의하시면 바로 보상절차가 진행됩니다.<br><br>
							보상은 팀머니와 무통장 입금 2가지 중 원하는 방식으로 지급됩니다. (무통장 진행 시 본인 계좌의 통장사본 이미지가 필요)<br><br>
							<strong>보상소요기간</strong><br>
							분실 보상에 필요한 모든 서류 제출한 시점부터 7일 이내 보상내용에 대해 고지, 14일 (영업일 기준) 이내 보상 처리 완료<br>
							택배사 파손 보상건은 1달이상 소요<br>
							국내 파손 및 분실은 택배사 기준을 적용 (CJ대한통운, 우체국택배, 로젠택배, 경동화물, 대신화물)</p>
					</li>
				</ul>
			</div>
			<div style="padding:0 10px;">
				<h4 class="text-left">보상 제외 사례</h4>	
			</div>
			<div class="reparation">
				<ol>
					<li>1. 입고일 기준 최장 3개월 이상 경과된 화물</li>
					<li>2. 중복 송장을 등록한 경우, 검수를 신청하지 않았거나 동일한 날에 작성된 신청서가 아닌 경우 사고 발생 시 보상에서 제외</li>
					<li>3. 검수를 신청하지 않은 경우</li>
					<li>4. 목재포장 및 이형물품 특수포장된 물품</li>
					<li>5. 검수 신청을 하였으나, 개봉 시 파손 위험이 있어 보이는 경우 검수 불가하며 사고 발생 시 보상에서 제외</li>
					<li>6. 재고 등록 상품 중 동일 상품 동일 트래킹 번호로 입고된 상품이 아닌 경우, 오배송 시 보상에서 제외</li>
					<li>7. 중고상품의 경우, 보상에서 제외됩니다.</li>
					<li>8. 신청서를 허위 작성 또는 정보를 누락하거나, 증빙자료를 허위로 제출하는 경우</li>
					<li>9. 신청서의 정보 누락으로 배송 지연, 분실, 오배송 등의 문제가 발생하는 경우</li>
					<li>10. 현지 고로켓고 물류센터 외의 곳으로 물품이 도착하거나, 고로켓고의 수취 정보가 없는 경우</li>
					<li>11. 보상 처리되는 상품의 회수를 거부하는 경우</li>
					<li>12. 사업자 용도로 이용되는 상품을 개인 수입 신고한 경우</li>
					<li>13. 입고 시 상태 확인이 불가한 경우 (예 : 진품/가품 구분, 전기제품의 정상작동 여부, 구성품 누락, 의류 재봉 불량, 지퍼/단추 등의 부자재 불량, 가죽 소재의 재질, 색차 등 세트/조립 상품의 부품 누락, 스크래치 등)</li>
					<li>14. 수집이나 판매 목적일지라도, 상품의 실사용과 관계없는 케이스, 박스 등의 파손의 경우</li>
					<li>15. 사고 접수 서류가 누락된 경우</li>
					<li>16. 포장과 관계없이 외부요인(온도 및 기압 등)에 의해 훼손 및 변형되는 경우</li>
					<li>17. 유리, 도자기, 피규어, 그릇, 플라스틱, 악기류, 액상제품, 가구류, 모니터류, 얇은 판낼 제품류 등 택배집하불가 및 파손면책 품목</li>
					<li>18. 일정 기일 내 미배송 시 상품가치가 소멸되거나 기회비용 손실 예상 물품</li>
					<li>19. 제공된 검수 도착사진을 확인하지 않을 경우 혹은 확인한 후 이상상태를 이의 제기를 하지 않을 경우</li>
					<li>20. 항공기의 연착 / 폭동, 파업, 전쟁, 노동쟁의, 사회적 요소 / 천재지변 및 자연재해로 인해 배송이 불가한 경우</li>
					<li>21. 수입금지품목</li>
					<li>22. 전자제품 – 충격 등으로 오작동이 발생할 수 있는 컴퓨터, 프린터기, 모니터, 노트북, 오디오, 가스레인지, 전자기 작동 주방용품 등</li>
					<li>23. 박스 형태의 상품 외 이형 상품 접수 불가</li>
					<li>24. 가구류는 조립 및 접이식 상품이 아닌 경우 접수 불가</li>
				</ol>
			</div>
			
			
			
			
			
		</div>
		
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	export default {
		components: {
			SupportBanner,
		},
		data() {
			return {
			}
		},
		created() {
	
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.title-wrap {
	    text-align: center;
	    color: var(--frontground-color);
	    margin-bottom: 60px;
	}
	.title-wrap h3 {
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    margin: 0 0 19px;
	}
	.title-wrap p {
	    font-size: 24px;
	    font-weight: 500;
	    line-height: 39px;
	    margin-bottom: 0;
	}
	.document-insure h4 {
	    font-size: 30px;
	    font-weight: 600;
	    text-align: center;
	    margin-bottom: 50px;
	}
	.expand-list .badge{
		font-size: 15px;
		color: var(--main-color);
		width: 50px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 40px;
		background: #f4f8ff;
		margin-right: 16px;	
	}
/* 	.expand-list .title{
		display: flex;
		align-items: center;
		height: 100px;
	} */
	.expand-list .name{
		font-size:18px;
		font-weight: 600;
	}
	.expand-list .expand-content{
		padding: 30px;
	}
	.expand-list .expand-content p {
	    font-size: 17px;
	    line-height: 29px;
	    margin-bottom: 29px;
	}
	.process ul {
	    list-style-type: none;
	    padding: 0;
	    margin: 0;
		color: var(--background-color);
	}
	.process ul li {
	    background: #f5f8fd;
	    padding: 38px 40px 24px;
	    border-radius: 20px;
	    margin-bottom: 14px;
	}
	.process ul li > strong {
	    font-size: 24px;
	    font-weight: 600;
	    display: flex;
	    align-items: center;
	    margin-bottom: 13px;
	}
	.process ul li > strong span {
	    font-size: 17px;
	    margin-left: 10px;
	}
	.process ul li p {
	    font-size: 17px;
	    line-height: 29px;
	}
	.text-left{
		border-bottom: 1px solid #e8e8e8;
		padding-bottom: 30px;
		margin-bottom: 30px;
		font-size: 30px;
		font-weight: 600;
		margin-top: 40px;
	}
	.reparation{
		margin:0 10px;
	}
	.reparation ol {
	    list-style-type: none;
	    padding-left: 0;
	    margin: 0;
	    line-height: 29px;
		font-size: 15px;
	}
	
	
	.visible-xs {
	    display: none !important;
	}
	.img-responsive{
		display: block;
		max-width: 100%;
		height: auto;
	}
	.center{
		display: flex;justify-content: center;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	.color-blue {
	    color: #0066ff !important;
	}
	.color-red {
	    color: #cc3333 !important;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-size: 18px;
			font-weight: bold;
			line-height: 23px;
		}
		.title-wrap p {
		    font-size: 13px;
		    line-height: 19px;
		    margin-bottom: 18px;
		}
		.document-insure h4 {
			font-size: 17px;
			margin-bottom: 20px;
		}
		.expand-list{
			padding:0 10px;
		}
		.expand-list .badge{
			font-size: 14px;
			height: 36px;
		}
		.expand-list .name{
			font-size:13px;
		}
		.process ul{
			margin:0 10px;
		}
		.process ul li {
		    padding: 19px 20px 9px;
		}
		.process ul li > strong {
		    font-size: 15px;
		}
		.process ul li > strong span {
		    font-size: 13px;
		}
		.process ul li p {
		    font-size: 13px;
		    line-height: 20px;
		}
		.text-left{
			font-size: 17px;
			padding-left: 10px;
			margin-bottom: 10px;
		}
		
		.reparation ol {
			font-size: 13px;
			padding: 0 0 30px;
		}
	
		
		.visible-xs {
		    display:block !important;
		}
		.hidden-xs {
			display: none !important;
		}
	}
</style>